import * as React from 'react';
import styled from "styled-components";
import { Page } from '../../containers';
import BrandedIconAndTitle from '../../BrandedIconAndTitle';
import BREAK_POINTS from '../../../styling/media-queries';

const StyledPage = styled(Page)`
    min-height: 400px;
`;
const BlockOnImage = styled.div`
  display: block;
  position: absolute;
  padding-left: 11%;
  padding-right: 22%;
  @media ${BREAK_POINTS.mobile} {
    padding-left: 7%;
    padding-right: 7%;
  }
`;

const BrandedIconAndTitleContainer = styled(BlockOnImage)`
  top: 4.2vh;
`

type Props = {
  name: string,
};

class ErrorPage extends React.Component<Props> {
  render() {
    const { name, children } = this.props;
    return (
      <StyledPage pageName={name}>
        <BrandedIconAndTitleContainer>
          <BrandedIconAndTitle color="#999999" />
        </BrandedIconAndTitleContainer>
        {children}
      </StyledPage>
    );
  }
}

export default ErrorPage;


// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/ErrorPages/components/ErrorPage.tsx